import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2b9e8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "booking-option-page" }
const _hoisted_3 = {
  key: 0,
  class: "option-title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-3" }, "◼️追加メニューを選択してください", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "option-wrapper pb-8" }
const _hoisted_7 = { class: "mx-0 w-full" }
const _hoisted_8 = { class: "w-full flex align-items-center mb-3" }
const _hoisted_9 = { class: "w-full flex flex-column ml-3 gap-2" }
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "w-full flex flex-grow-1 flex-row align-items-baseline justify-content-between" }
const _hoisted_12 = { class: "font-bold text-red-400 text-105rem" }
const _hoisted_13 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = {
  key: 0,
  class: "readmore-btn-wrap align-content-end w-full flex justify-content-center flex-wrap mb-5"
}
const _hoisted_16 = { class: "controller-wrapper" }
const _hoisted_17 = {
  key: 1,
  class: "loading-wrapper"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

import { onMounted, ref, computed } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * HTTPクライアント
 * APIリクエストの送信に使用
 */
import axios from "axios";
/**
 * 数値フォーマットユーティリティ
 * 金額の表示形式を整形するために使用
 */
import NumberUtils from "@/clinic/utils/number-utils";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "../constants/router.constants";
/**
 * APIルーティング定数
 * APIエンドポイントの定義に使用
 */
import ApiRouterConstants from "../../common/constants/api.router.constants";
/**
 * HTMLコンテンツユーティリティ
 * テキストの行数カウントに使用
 */
import htmlContent from "@/common/utils/html.content";
/**
 * 予約プレビューコンポーネント
 * 選択内容のプレビュー表示に使用
 */
import BookingPreview from "@/customer/components/BookingPreview.vue";
/**
 * 予約設定サービス
 * 予約設定の取得に使用
 */
import { BookingSettingService } from "@/customer/services";
/**
 * スタッフ配分サービス
 * スタッフの自動配分処理に使用
 */
import StaffDistributionService from "@/clinic/services/customer/staff-distribution.services";
/**
 * スタッフの型定義
 */
import { IStaff } from "@/clinic/typings/entities/staff";
/**
 * 予約設定の型定義
 */
import { IBookingSetting } from "@/clinic/typings/entities/booking-setting";

/**
 * 選択されたオプションのIDリスト
 * @type {Ref<number[]>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingOption',
  setup(__props) {

/**
 * 予約オプション画面コンポーネント
 * 予約時の追加メニュー（オプション）の選択を行う画面
 * オプションメニューの表示、選択、次画面への遷移機能を提供
 */

/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
const selectedOptions = ref([]);

/**
 * 選択されたメニューの施術時間
 * @type {Ref<number>}
 */
const selectedMenuTime = ref(0);

/**
 * オプションメニューのリスト
 * @type {Ref<any[]>}
 */
const bookingOpts = ref();

/**
 * Vuexストアインスタンス
 */
const store = useStore();

/**
 * メニュー説明文のDOM要素リスト
 * @type {Ref<HTMLElement[]>}
 */
const menuContentElements = ref([]);

/**
 * オプション選択が必須かどうか
 * @type {Ref<boolean>}
 */
const optionRequire = ref(false);

/**
 * スタッフリスト
 * @type {Ref<IStaff[]>}
 */
const staffList = ref<IStaff[]>([]);

/**
 * 予約設定
 * @type {Ref<IBookingSetting | null>}
 */
const bookingSetting = ref<IBookingSetting | null>(null);

/**
 * 初期化完了フラグ
 * @type {Ref<boolean>}
 */
const isInitialized = ref(false);

/**
 * 指名予約モードかどうか
 * @type {ComputedRef<boolean>}
 */
const isNominate = computed(() => bookingSetting.value?.option === "nominate");

/**
 * 予約プレビューに表示する属性一覧
 * @type {ComputedRef<string[] | null>}
 */
const bookingPreviewAttributes = computed(() => {
  if (!isInitialized.value) return null;
  return isNominate.value ? ["staffName", "orderPrice", "menuName"] : ["menuName"];
});

/**
 * オプションメニューの価格を表示用にフォーマット
 * @param {Object} menu - オプションメニュー情報
 * @returns {string} フォーマットされた価格
 */
const menuOptionPrice = (menu: { display_price: boolean; unit_price: number }) =>
  menu.display_price ? NumberUtils.formatJPCurrency(menu.unit_price) : "";

/**
 * スタッフ選択画面への遷移処理
 * 選択されたオプションを保存し、スタッフ選択画面に遷移する
 */
const goToStaff = () => {
  // オプション必須で未選択の場合は遷移しない
  if (optionRequire.value == true && selectedOptions.value.length == 0) {
    return;
  }
  // 選択されたオプションを抽出
  let options = bookingOpts.value.filter((option: { id: number }) => {
    return Object.values(selectedOptions.value).includes(option.id);
  });
  // 選択されたオプションを保存
  store.commit("booking/selectOptions", options);
  // スタッフ選択画面に遷移
  RouterUtils.goTo(RouterConstants.BOOKING_ROUTER_NAME);
};

/**
 * カレンダー画面への遷移処理
 * 選択されたオプションを保存し、指名予約でない場合はデフォルトスタッフを設定してからカレンダー画面に遷移する
 */
const goToCalendar = async () => {
  // オプション必須で未選択の場合は遷移しない
  if (optionRequire.value == true && selectedOptions.value.length == 0) {
    return;
  }
  // 選択されたオプションを抽出
  let options = bookingOpts.value.filter((option: { id: number }) => {
    return Object.values(selectedOptions.value).includes(option.id);
  });
  // 選択されたオプションを保存
  store.commit("booking/selectOptions", options);

  // 指名受付不可の場合は、デフォルトスタッフを設定
  if (!isNominate.value) {
    // スタッフリストを取得
    const res = await axios.get(ApiRouterConstants.API_STAFF, {
      params: { clinic_id: store.getters["line_account/clinicId"] },
      headers: { Accept: "application/json" },
    });
    // medical_menu_idsに選択中メニューIDが含まれるスタッフのみを抽出
    const staffList = res.data.filter((staff: IStaff) =>
      staff.medical_menu_ids.includes(store.getters["booking/selectedMenu"].id)
    );
    // デフォルトスタッフを探す（紐づきかつdefault_staffフラグが立っているものを優先）
    const defaultStaff =
      staffList.find((staff: IStaff) => staff.default_staff) ||
      res.data.find((staff: IStaff) => staff.default_staff) ||
      null;

    if (defaultStaff) {
      // スタッフ情報を設定
      store.commit("booking/selectStaff", defaultStaff);
      store.commit("booking/setStaffOrderPrice", defaultStaff.order_price);
      store.commit("booking/setUseDefaultStaff", true);
      store.commit("booking/setSelectedStaffId", defaultStaff.id);
      // 自動スタッフ配分処理を実行
      const { data } = await StaffDistributionService.getStaff({
        clinic_id: store.getters["line_account/clinicId"],
        medical_menu_id: store.getters["booking/selectedMenu"].id,
      });
      const distributedStaffIds = data.value as unknown as number[];
      if (distributedStaffIds && distributedStaffIds.length > 0) {
        // 配分リストが存在する場合
        store.commit("booking/setAutoStaffDistributionData", distributedStaffIds);
        store.commit("bookingSetting/setAutoStaffDistribution", true);
        // デフォルトスタッフが配分リストに含まれていない場合は追加
        if (!distributedStaffIds.includes(defaultStaff.id)) {
          store.commit("booking/setAutoStaffDistributionData", [...distributedStaffIds, defaultStaff.id]);
        }
      } else {
        // 配分リストが空の場合はデフォルトスタッフのみを設定
        store.commit("booking/setAutoStaffDistributionData", [defaultStaff.id]);
        store.commit("bookingSetting/setAutoStaffDistribution", true);
      }
    }
  }
  // カレンダー画面に遷移
  RouterUtils.goTo(RouterConstants.BOOKING_CALENDAR_ROUTER_NAME);
};

/**
 * 「もっと見る」ボタンクリック時の処理
 * メニュー説明文の全文表示とボタンの非表示を行う
 * @param {Event} event - クリックイベント
 * @param {number} index - メニューのインデックス
 */
const handleReadMore = (event: Event, index: number) => {
  event.stopPropagation();

  if (menuContentElements.value[index]) {
    menuContentElements.value[index].classList.remove("readmore");
  }

  event.target.closest(".readmore-btn-wrap").style.visibility = "hidden";
  event.target.closest(".readmore-btn-wrap").style.height = "0";
};

/**
 * メニュー説明文が複数行かどうかを判定
 * @param {number} index - メニューのインデックス
 * @returns {boolean} 複数行の場合はtrue
 */
const manyLines = (index: number) => {
  const element = menuContentElements.value[index];
  if (!element) return false;

  return element.classList?.contains("readmore") || htmlContent.countLines(element) > 5;
};

/**
 * 戻るボタンクリック時の処理
 * メニュー選択画面に戻る
 */
const back = () => {
  RouterUtils.goTo(RouterConstants.BOOKING_MENU_ROUTER_NAME);
};

/**
 * チェックボックスのIDを生成
 * @param {number} index - メニューのインデックス
 * @returns {string} チェックボックスのID
 */
const checkboxId = (index: number) => {
  return `checkbox-${index}`;
};

/**
 * スタッフ紐付きがないかどうか
 * @type {ComputedRef<boolean>}
 */
const noStaff = computed(() => staffList.value.length === 0);

/**
 * コンポーネントのマウント時の処理
 * 予約設定の取得、オプションメニューの取得、初期化を行う
 */
onMounted(async () => {
  // bookingSettingの初期化を最初に行う
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  store.commit("bookingSetting/setBookingSetting", settings.value);
  bookingSetting.value = settings.value;

  // bookingSettingの初期化後にoptionRequireを設定
  optionRequire.value = store.getters["bookingSetting/optionRequire"];

  // 選択したメニューを取得
  const selectedMenu = store.getters["booking/selectedMenu"];

  // スタッフ一覧を取得して staffList に格納
  const staffRes = await axios.get(ApiRouterConstants.API_STAFF, {
    params: { clinic_id: store.getters["line_account/clinicId"] },
    headers: { Accept: "application/json" },
  });

  staffList.value = staffRes.data.filter((staff: IStaff) => staff.medical_menu_ids.includes(selectedMenu.id));

  // オプションメニュー一覧を取得
  const res = await axios.get(ApiRouterConstants.API_MENU_OPTION, {
    params: {
      clinic_id: store.getters["line_account/clinicId"],
      menu_id: store.getters["booking/selectedMenu"].id,
    },
    headers: { Accept: "application/json" },
  });
  bookingOpts.value = res.data;
  selectedOptions.value = store.getters["booking/selectedOptions"].map((option: { id: number }) => option.id);
  selectedMenuTime.value = store.getters["booking/selectedMenu"].time;
  store.commit("booking/selectOptions", []);
  isInitialized.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (isInitialized.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(isNominate))
          ? (_openBlock(), _createBlock(BookingPreview, {
              key: 0,
              previewAttributes: _unref(bookingPreviewAttributes)
            }, null, 8, ["previewAttributes"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (bookingOpts.value?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingOpts.value, (bookingOpt, index) => {
              return (_openBlock(), _createBlock(_component_Card, { key: bookingOpt }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Checkbox, {
                        inputId: checkboxId(index),
                        value: bookingOpt.id,
                        modelValue: selectedOptions.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event))
                      }, null, 8, ["inputId", "value", "modelValue"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", {
                          for: checkboxId(index),
                          class: "font-semibold text-base"
                        }, _toDisplayString(bookingOpt.name), 9, _hoisted_10),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _createTextVNode(_toDisplayString(menuOptionPrice(bookingOpt)) + " ", 1),
                            (bookingOpt.display_price)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(税込)"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(bookingOpt.time_unit) + "分 ", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("p", {
                      ref_for: true,
                      ref: el => (menuContentElements.value[index] = el),
                      class: _normalizeClass({ readmore: manyLines(index) })
                    }, _toDisplayString(bookingOpt.description), 3),
                    (manyLines(index))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_Button, {
                            class: "readmore-btn",
                            onClick: ($event: any) => (handleReadMore($event, index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("もっと見る")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Button, {
              class: "btn cancel-btn w-full",
              onClick: back
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            }),
            (_unref(isNominate) && !_unref(noStaff))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "btn accept-btn w-full",
                  onClick: goToStaff
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" スタッフ選択へ ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn accept-btn w-full",
                  onClick: goToCalendar
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("日時選択へ")
                  ]),
                  _: 1
                }))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
}
}

})